module.exports = __webpack_public_path__ + "assets/img/ADVANCED_LOGIC_PLUGIN.d6520d54.svg";